import { SwiperProps } from "swiper/react";

export const centeredSwiperConfiguration: SwiperProps = {
	centeredSlides: true,
	centeredSlidesBounds: true,
	slidesPerView: "auto",
	slidesPerGroupAuto: true,
	spaceBetween: 12,
	observer: true,
	threshold: 10,
};
